// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__mnHjI","label":"Section_label__3sG2d","contentWrap":"Section_contentWrap__3v9Vx","footer":"Section_footer__1ce1k","footerInner":"Section_footerInner__1y-uZ"};